import React from "react";
import cphereHeaderLogo from "../assets/Cphere Logo New.png";

function sanitizeBrandLogoClassName(className) {
  const tokens = String(className || "")
    .split(/\s+/)
    .map((token) => token.trim())
    .filter(Boolean);

  const disallowedTokens = tokens.filter((token) => /poweredby/i.test(token));

  if (disallowedTokens.length > 0 && process.env.NODE_ENV !== "production") {
    console.warn(
      "[CphereHeaderLogo] Ignoring powered-by era class token(s):",
      disallowedTokens.join(", "),
      "Use wrapper-level layout classes instead of restyling the shared brand logo."
    );
  }

  return tokens.filter((token) => !/poweredby/i.test(token)).join(" ");
}

export default function CphereHeaderLogo({
  className = "",
  alt = "Cphere",
  onClick,
  style,
  ...rest
}) {
  // Canonical New Cphere Logo contract:
  // - this component owns the shared brand-logo sizing/alignment treatment
  // - powered-by classes must not be passed into it
  // - page wrappers may control surrounding layout, but page-local sizing overrides
  //   should not restyle the logo itself
  const safeClassName = sanitizeBrandLogoClassName(className);

  return (
    <img
      src={cphereHeaderLogo}
      alt={alt}
      className={`cphere-header-logo cphere-brand-header-logo ${safeClassName}`.trim()}
      onClick={onClick}
      style={{
        width: "100%",
        height: "auto",
        objectFit: "contain",
        ...style,
      }}
      {...rest}
    />
  );
}
